import { createFileRoute, redirect } from '@tanstack/react-router';

/** Customizations moved into catalog setup; old links and bookmarks land on its tab. */
export const Route = createFileRoute('/_authed/_active/org/customizations')({
  beforeLoad: () => {
    throw redirect({ to: '/org/catalog-setup/customizations' });
  },
});
